export default __webpack_public_path__ + "static/media/logo.2365c60c.svg";